import React from "react";
export default function Paginator({page, total, size, onPage, onSize}){
  const pages = Math.max(1, Math.ceil(total/size));
  return (
    <div className="d-flex align-items-center gap-2">
      <button className="btn btn-sm btn-outline-secondary" disabled={page<=1} onClick={()=>onPage(page-1)}>이전</button>
      <span className="small">{page} / {pages}</span>
      <button className="btn btn-sm btn-outline-secondary" disabled={page>=pages} onClick={()=>onPage(page+1)}>다음</button>
      <select className="form-select form-select-sm" style={{width:80}} value={size} onChange={e=>onSize(Number(e.target.value))}>
        {[10,20,50].map(n=><option key={n} value={n}>{n}/페이지</option>)}
      </select>
    </div>
  );
}
